import React from "react";
import CommonLayout from "./CommonLayout";

const VendorStatus = () => {
  return (
    <div>
      <CommonLayout>
        <div className="space-y-6 sm:space-y-8">
          {/* HEADING */}
          <h2 className="text-3xl font-semibold">Status Toko</h2>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
          {/*// TODO: Buat grafik untuk jumlah view, */}
          <p>Fitur dashboard vendor akan segera hadir untuk anda</p>
        </div>
      </CommonLayout>
    </div>
  );
};

export default VendorStatus;
